<template>
  <header :class="$route.name==='article'||$route.name==='how'?'header-white':'header'">
    <div class='container'>
      <div class="header__wrapper">
        <router-link to="/" class="header__logo" v-if="$route.name!=='article'&&$route.name!=='how'">
          <img class="header__logo-link" src="/static/img/header/logo.svg" alt="Логотип" width="167" height="50" />
          <img class="m-logo" src="/static/img/header/m-logo.svg" alt="Логотип" width="120" height="36" />
        </router-link>
        <router-link to="/" class="header__logo" v-else>
          <img class="header__logo-link" src="/static/img/header/logo-w.svg" alt="Логотип" width="167" height="50" />
          <img class="m-logo" src="/static/img/header/m-logo.svg" alt="Логотип" width="120" height="36" />
        </router-link>
        <div class="header__burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <nav class="header__menu">
          <ul class="menu__list">
            <li><router-link to="/groups/373" class="menu__link">Быстрый возврат прав</router-link></li>
            <li><router-link to="/how-it-works" class="menu__link">Как это работает</router-link></li>
            <li><router-link to="/win" class="menu__link">Как самому выиграть дело в суде</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'header',
  data () {
    return {
      url: null
    }
  },
  created () {
    this.url = this.$router.currentRoute.path
  },
  watch: {
    $route (to, from) {
      this.url = to.path
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/include/header.vue